export const formatTime = (hour: number | undefined) => {
    const ampm = (hour ?? 0) >= 12 ? "PM" : "AM";
    hour = (hour ?? 0) % 12 || 12; // convert 0 → 12, 13 → 1
    return `${hour} ${ampm}`;
};